import { CountyBase } from './base/county-base';

export class County extends CountyBase { }